// pages/Logout.jsx
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../pages/contexts/AuthContext';

const Logout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    logout();             
    navigate('/');   
  }, [logout, navigate]);

  return null;
};

export default Logout;
